import request from '../utils/request.js'

/***************** 价格模板接口 *****************/

/**
 * 添加价格模板
 * @param params
 * @returns {AxiosPromise}
 */
export function add(params) {
    return request({
        url: '/api/price_template',
        method: 'post',
        data: params
    })
}




/**
 * 删除模板价格设置
 * @param params
 * @returns {AxiosPromise}
 */
export function deltemplate(id) {
    return request({
        url: `/api/price_template/${id}`,
        method: 'delete'
    })
}


/**
 * 价格模板详情
 * @param params
 * @returns {AxiosPromise}
 */
export function detail(id) {
    return request({
        url: '/api/price_template/' + id,
        method: 'get'
    })
}


/**
 * 添加价格模板设置
 * @param params
 * @returns {AxiosPromise}
 */
export function add_set(params) {
    return request({
        url: '/api/price_item',
        method: 'post',
        data: params
    })
}

/**
 * 查询价格设置
 * @param {*} params 
 * @returns 
 */
export function set_list(params) {
    return request({
        url: '/api/price_item',
        method: 'get',
        params: params
    })
}

/**
 * 查询价格模板
 * @param {*} params 
 * @returns 
 */
export function list(params) {
    return request({
        url: '/api/price_template',
        method: 'get',
        params: params
    })
}

/**
 * 删除模板价格设置
 * @param params
 * @returns {AxiosPromise}
 */
export function del(id) {
    return request({
        url: `/api/price_item/${id}`,
        method: 'delete'
    })
}


/**
 * 模板数据
 * @param params
 * @returns {AxiosPromise}
 */
export function templates() {
    return request({
        url: `/api/price_template/items`,
        method: 'get'
    })
}

/**
 * 城市集合
 * @param params
 * @returns {AxiosPromise}
 */
export function cities() {
    return request({
        url: `/api/price_item/cities`,
        method: 'get'
    })
}
/**
 * 地区接口
 * @param params
 * @returns {AxiosPromise}
 */
 export function area(params) {
    return request({
        url: `/api/area`,
        method: 'get',
        params: params
    })
}
/**
 * 省份城市数据
 * @param params
 * @returns {AxiosPromise}
 */
 export function areaList() {
    return request({
        url: `/api/area/list`,
        method: 'get',
    })
}

/*************************  点餐  ************************* */

/**
 * 查询价格模板
 * @param {*} params 
 * @returns 
 */
export function restaurantlist(params) {
    return request({
        url: '/api/mahua_price_template',
        method: 'get',
        params: params
    })
}



/**
 * 价格选项
 * @param {*} params 
 * @returns 
 */
export function price_template_items() {
    return request({
        url: `/api/mahua_price_template/items`,
        method: 'get',
    })
}


/**
 * 添加价格模板设置
 * @param params
 * @returns {AxiosPromise}
 */
export function add_muhua_price(params) {
    return request({
        url: '/api/mahua_price_template',
        method: 'post',
        data: params
    })
}

/**
 * 删除选项
 * @param params
 * @returns {AxiosPromise}
 */
export function del_restaurant_item(id) {
    return request({
        url: `/api/mahua_price_item/${id}`,
        method: 'delete'
    })
}


/**
 * 删除模板
 * @param params
 * @returns {AxiosPromise}
 */
export function del_restaurant(id) {
    return request({
        url: `/api/mahua_price_template/${id}`,
        method: 'delete'
    })
}


/**
 * 添加价格模板设置item
 * @param params
 * @returns {AxiosPromise}
 */
export function add_muhua_set(params) {
    return request({
        url: '/api/mahua_price_item',
        method: 'post',
        data: params
    })
}

/**
 * 查询价格设置
 * @param {*} params 
 * @returns 
 */
export function price_template_detail(id) {
    return request({
        url: `/api/mahua_price_template/${id}`,
        method: 'get',
    })
}




/*************************  油卡  ************************* */


/**
 * 查询油卡价格模板
 * @param {*} params 
 * @returns 
 */
export function oillist(params) {
    return request({
        url: '/api/oilcard_charge_template',
        method: 'get',
        params: params
    })
}

/**
 * 添加油卡价格模板
 * @param params
 * @returns {AxiosPromise}
 */
export function addoil(params) {
    return request({
        url: '/api/oilcard_charge_template',
        method: 'post',
        data: params
    })
}

/**
 * 油卡价格模板详情
 * @param params
 * @returns {AxiosPromise}
 */
export function oildetail(id) {
    return request({
        url: '/api/oilcard_charge_template/' + id,
        method: 'get'
    })
}

/**
 * 删除油卡模板价格设置
 * @param params
 * @returns {AxiosPromise}
 */
export function deloil(id) {
    return request({
        url: `/api/oilcard_charge_template/${id}`,
        method: 'delete'
    })
}



/**
 * 油卡模板数据
 * @param params
 * @returns {AxiosPromise}
 */
export function oiltemplates() {
    return request({
        url: `/api/oilcard_charge_template/items`,
        method: 'get'
    })
}


/*************************  话费  ************************* */


/**
 * 查询话费价格模板
 * @param {*} params 
 * @returns 
 */
export function tellist(params) {
    return request({
        url: '/api/telephone_charge_template',
        method: 'get',
        params: params
    })
}

/**
 * 添加话费价格模板
 * @param params
 * @returns {AxiosPromise}
 */
export function addtel(params) {
    return request({
        url: '/api/telephone_charge_template',
        method: 'post',
        data: params
    })
}

/**
 * 话费价格模板详情
 * @param params
 * @returns {AxiosPromise}
 */
export function teldetail(id) {
    return request({
        url: '/api/telephone_charge_template/' + id,
        method: 'get'
    })
}

/**
 * 删除话费模板价格设置
 * @param params
 * @returns {AxiosPromise}
 */
export function deltel(id) {
    return request({
        url: `/api/telephone_charge_template/${id}`,
        method: 'delete'
    })
}


/**
 * 话费模板数据
 * @param params
 * @returns {AxiosPromise}
 */
export function teltemplates() {
    return request({
        url: `/api/telephone_charge_template/items`,
        method: 'get'
    })
}


/********************   商品价格模板 ******************** */

/**
 * 查询价格模板
 * @param {*} params 
 * @returns 
 */
export function goodsTemplates(params) {
    return request({
        url: '/api/goods_template',
        method: 'get',
        params: params
    })
}


/**
 * 保存价格模板
 * @param {*} params 
 * @returns 
 */
export function saveGoodsTemplates(params) {
    return request({
        url: '/api/goods_template',
        method: 'post',
        data: params
    })
}

/**
 * 价格模板详情
 * @param {*} params 
 * @returns 
 */
export function goodsTemplateDetail(id) {
    return request({
        url: `/api/goods_template/${id}`,
        method: 'get',
    })
}


/**
 * 删除价格模板
 * @param {*} params 
 * @returns 
 */
export function delGoodsTemplate(id) {
    return request({
        url: `/api/goods_template/${id}`,
        method: 'delete',
    })
}

/**
 * 价格模板集合
 * @param {*} params 
 * @returns 
 */
export function goodsTemplatesItems() {
    return request({
        url: `/api/goods_template/items`,
        method: 'get',
    })
}



/**
 * 导出
 * @param {*} params 
 * @returns 
 */
export function exportGoods(id) {
    return request({
        url: `/api/goods_template/export/${id}`,
        method: 'get',
    })
}

/********************   物流模版 ******************** */
/**
 * 商家物流模版
 * @param {*} params 
 * @returns 
 */
 export function getLogisticsTemplateList(params) {
    return request({
        url: `/api/logistics_template/list`,
        method: 'get',
        params:params
    })
}
/**
 * 查询物流模版
 * @param {*} params 
 * @returns 
 */
 export function getLogisticsTemplate(params) {
    return request({
        url: `/api/logistics_template`,
        method: 'get',
        params:params
    })
}
/**
 * 保存物流模版
 * @param {*} params 
 * @returns 
 */
 export function postLogisticsTemplate(params) {
    return request({
        url: `/api/logistics_template`,
        method: 'post',
        data:params
    })
}
/**
 * 查询物流模版详情
 * @param {*} params 
 * @returns 
 */
 export function getLogisticsTemplateId(id) {
    return request({
        url: `/api/logistics_template/${id}`,
        method: 'get',
    })
}
/**
 * 删除物流模版
 * @param {*} params 
 * @returns 
 */
 export function delLogisticsTemplateId(id) {
    return request({
        url: `/api/logistics_template/${id}`,
        method: 'delete',
    })
}

/********************   本地价格模板 ******************** */
/**
 * 查询价格模版
 * @param {*} params 
 * @returns 
 */
 export function getLocalTemplate(params) {
    return request({
        url: `/api/local_cater_price_template`,
        method: 'get',
        params:params
    })
}
/**
 * 保存价格模版
 * @param {*} params 
 * @returns 
 */
 export function postLocalTemplate(params) {
    return request({
        url: `/api/local_cater_price_template`,
        method: 'post',
        data:params
    })
}
/**
 * 查询价格模版详情
 * @param {*} params 
 * @returns 
 */
 export function getLocalTemplateId(id) {
    return request({
        url: `/api/local_cater_price_template/${id}`,
        method: 'get',
    })
}
/**
 * 删除价格模版
 * @param {*} params 
 * @returns 
 */
 export function delLocalTemplate(id) {
    return request({
        url: `/api/local_cater_price_template/${id}`,
        method: 'delete',
    })
}
/**
 * 价格模版选项集合
 * @param {*} params 
 * @returns 
 */
 export function getLocalTemplateItems(params) {
    return request({
        url: `/api/local_cater_price_template/items`,
        method: 'get',
        params:params
    })
}


/**
 * 碰一碰查询价格模板
 * @param {*} params 
 * @returns 
 */
export function getTouchPriceTemplate(params) {
    return request({
        url: `/api/touch_price_template`,
        method: 'get',
        params:params
    })
}
/**
 * 碰一碰保存价格模版
 * @param {*} params 
 * @returns 
 */
export function postTouchPriceTemplate(params) {
    return request({
        url: `/api/touch_price_template`,
        method: 'post',
        data:params
    })
}
/**
 * 碰一碰查询价格模版详情
 * @param {*} params 
 * @returns 
 */
 export function getTouchPriceTemplateId(id) {
    return request({
        url: `/api/touch_price_template/${id}`,
        method: 'get',
    })
}
/**
 * 碰一碰删除价格模版
 * @param {*} params 
 * @returns 
 */
 export function delTouchPriceTemplate(id) {
    return request({
        url: `/api/touch_price_template/${id}`,
        method: 'delete',
    })
}


/**
 * 保存价格模板
 * @param {*} params 
 * @returns 
 */
export function postFxzbPriceTmpl(params) {
    return request({
        url: '/api/fxzb_price_tmpl',
        method: 'post',
        data: params
    })
}
/**
 * 价格模板详情
 * @param {*} params 
 * @returns 
 */
export function fxzbPriceTmplGet(params) {
    return request({
        url: `/api/fxzb_price_tmpl/get`,
        method: 'get',
        params: params
    })
}
/**
 * 保存商品承包接口
 * @param params
 * @returns {AxiosPromise}
 */
export function postFxzbGoodsContract(params) {
    return request({
        url: `/api/fxzb_goods_contract`,
        method: 'post',
        data: params
    })
}

/**
 * 商品承包详情接口
 * @param params
 * @returns {AxiosPromise}
 */
export function fxzbGoodsContractDetail(params) {
    return request({
        url: '/api/fxzb_goods_contract/detail',
        method: 'get',
        params: params
    })
}